import { LinearProgress } from '@material-ui/core';

export default function LoadingScreen(){
    return(
        <LinearProgress />
    )
}